import React, { useState } from "react";
import styled from "styled-components";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import { useNavigate } from "react-router-dom";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import MainInput from "./../../../component/atoms/input/mainInput";
import EventBtn from "./../../../component/atoms/button/eventBtn";
import Radio from "./../../../component/atoms/input/radio";

const OperationData = () => {
  const navigate = useNavigate();

  const [eCommerceTrackingStatus, setECommerceTrackingStatus] = useState(false);

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>데이터 연결</TableTitle>

          {/* Google 애널리틱스(웹로그 분석) */}
          <DataItemContainer>
            <DataItemTitleWrapper>
              <DataItemTitle>Google 애널리틱스(웹로그 분석)</DataItemTitle>
              <DataItemTitleDescription>
                무료이면서도 매우 전문적인 방문자 분석 도구를 제공합니다. 지금
                사이트 접속자 수가 몇 명이고
                <br />
                어떤 경로를 통해 왔으며, 어떤 페이지를 보고 있고 어디서
                이탈했는지 확인할 수 있습니다.
              </DataItemTitleDescription>
            </DataItemTitleWrapper>
            <DataActiveWrapper>
              <DataInputWrapper>
                <DataInputTitle>애널리틱스 ID</DataInputTitle>
                <MainInput
                  type={"text"}
                  placeholder={"G-로 시작하는 측정 ID"}
                  style={{ width: "338px" }}
                  value={""}
                  onChange={() => {}}
                />
              </DataInputWrapper>
              <DataInputWrapper>
                <DataInputTitle>전자상거래용 추적사용</DataInputTitle>
                <DataInputTitleDescription>
                  미사용시 일반 페이지 뷰에 대한 추적만 가능합니다.
                </DataInputTitleDescription>
                <DataRadioWrapper>
                  <Radio
                    id={""}
                    valueText={"사용 안함"}
                    checked={!eCommerceTrackingStatus}
                    onChange={() => {
                      setECommerceTrackingStatus(false);
                    }}
                  />
                  <Radio
                    id={""}
                    valueText={"사용함"}
                    checked={eCommerceTrackingStatus}
                    onChange={() => {
                      setECommerceTrackingStatus(true);
                    }}
                  />
                </DataRadioWrapper>
              </DataInputWrapper>
              <EventBtn onClick={() => {}} text={"저장하기"} />
            </DataActiveWrapper>
          </DataItemContainer>

          {/* 네이버 애널리틱스/프리미엄 로그 분석) */}
          <DataItemContainer>
            <DataItemTitleWrapper>
              <DataItemTitle>
                네이버 애널리틱스/프리미엄 로그 분석)
              </DataItemTitle>
              <DataItemTitleDescription>
                네이버에서 제공하는 방문자 및 네이버 키워드 광고 효과분석을 위한
                도구입니다.
              </DataItemTitleDescription>
            </DataItemTitleWrapper>
            <DataActiveWrapper>
              <DataInputWrapper>
                <DataInputTitle>네이버 공통 인증키</DataInputTitle>
                <MainInput
                  type={"text"}
                  placeholder={"발급받은 네이버 공통 인증키"}
                  style={{ width: "338px" }}
                  value={""}
                  onChange={() => {}}
                />
                <DataInputTitleDescription>
                  네이버페이를 설정한 경우 네이버페이와 동일한 네이버 공통
                  인증키를 사용하셔야 합니다.
                </DataInputTitleDescription>
              </DataInputWrapper>
              <EventBtn onClick={() => {}} text={"저장하기"} />
            </DataActiveWrapper>
          </DataItemContainer>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default OperationData;

const DataItemContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  padding: 24px 0px;
  gap: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
`;

const DataItemTitleWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const DataItemTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 18px;
  line-height: 32.5px;
  letter-spacing: -0.3%;
  color: #27beff;
`;

const DataItemTitleDescription = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
`;

const DataInputTitleDescription = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: rgba(181, 181, 181, 0.5);
`;

const DataActiveWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const DataInputWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const DataInputTitle = styled(PretendardText).attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;

const DataRadioWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 12px;
`;
